// Loqate returns the state/province as a romanized English name, while the State
// <select> is keyed by region code from country-region.json, whose names use a
// different spelling per country. Map the Loqate name onto one of the form's
// options; return null when there is no confident match so the customer picks the
// state themselves instead of silently getting a wrong one.

const normalize = value =>
  String(value || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()

// Loqate (English) region name -> option code in country-region.json.
// Greece names were taken from live Loqate Retrieve responses; the rest of the
// Greek regions follow Loqate's English naming for the 13 regions + Mount Athos.
const GREEK_REGION_CODES = {
  attica: 'I',
  'central macedonia': 'B',
  'west macedonia': 'C',
  'western macedonia': 'C',
  'east macedonia and thrace': 'A',
  thessaly: 'E',
  epirus: 'D',
  'ionian islands': 'F',
  'west greece': 'G',
  'western greece': 'G',
  'central greece': 'H',
  peloponnese: 'J',
  'north aegean': 'K',
  'south aegean': 'L',
  crete: 'M',
  'mount athos': '69',
}

const CODE_ALIASES_BY_COUNTRY = {
  GR: GREEK_REGION_CODES,
}

// Alternate names (normalized) that should resolve to another normalized name
// already present in the form's list.
const NAME_ALIASES_BY_COUNTRY = {
  IN: {'new delhi': 'delhi'},
  VN: {'ho chi minh': 'ho chi minh sai gon'},
  PH: {
    'occidental mindoro': 'mindoro occidental',
    'oriental mindoro': 'mindoro oriental',
  },
}

export const resolveStateOption = (countryCode, stateName, listOfStates) => {
  const wanted = normalize(stateName)
  if (!wanted || !Array.isArray(listOfStates) || !listOfStates.length) {
    return null
  }

  const country = String(countryCode || '').toUpperCase()
  const byName = name => listOfStates.find(s => normalize(s.name) === name)

  const direct = byName(wanted)
  if (direct) return direct

  const aliasName = NAME_ALIASES_BY_COUNTRY[country]?.[wanted]
  const aliased = aliasName && byName(aliasName)
  if (aliased) return aliased

  const code = CODE_ALIASES_BY_COUNTRY[country]?.[wanted]
  if (code) {
    return listOfStates.find(s => s.value === code) || null
  }

  return null
}
